import { render, staticRenderFns } from "./EmailInfoIndex.vue?vue&type=template&id=4f6fa85c&scoped=true"
import script from "./EmailInfoIndex.vue?vue&type=script&lang=js"
export * from "./EmailInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./EmailInfoIndex.vue?vue&type=style&index=0&id=4f6fa85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6fa85c",
  null
  
)

export default component.exports